import { getPrimaryPhaseRowMetricValue } from './orderPrimaryPhaseMetric';
import { resolveOrderDimensionKey, resolveOrderDimensionLabel } from './orderPrimaryPhaseDimension';
import { accumulatePrimaryPhaseOrderFinancials } from './primaryPhaseOrderFinancials';
import { buildStatisticsMaterialScopedOrder } from '../../../filters/lib/statisticsMaterialLineContribution';

const createEmptyBucket = (key, label) => ({
	key,
	label,
	count: 0,
	totalPrice: 0,
	receivableTotal: 0,
	quasiReceivableTotal: 0,
	pendingPrepaymentTotal: 0,
	paidPrepaymentTotal: 0,
	orders: [],
});

/** 按销售员或客户聚合当前订单列表（与主阶段财务字段对齐；物料筛选按匹配行） */
export const aggregatePrimaryPhaseOrdersByDimension = (orders, dimension, { topN, filters = {} } = {}) => {
	const buckets = new Map();

	for (const order of orders ?? []) {
		const statsOrder = buildStatisticsMaterialScopedOrder(order, filters);
		const key = resolveOrderDimensionKey(statsOrder, dimension);
		const label = resolveOrderDimensionLabel(statsOrder, dimension);
		if (!buckets.has(key)) {
			buckets.set(key, createEmptyBucket(key, label));
		}
		const bucket = buckets.get(key);
		accumulatePrimaryPhaseOrderFinancials(bucket, statsOrder);
		bucket.orders.push(order);
	}

	const rows = [...buckets.values()].sort(
		(a, b) => getPrimaryPhaseRowMetricValue(b, 'totalPrice') - getPrimaryPhaseRowMetricValue(a, 'totalPrice') || b.count - a.count,
	);

	if (typeof topN === 'number' && topN > 0) {
		return rows.slice(0, topN);
	}
	return rows;
};
